<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 13.019V15.579C0 15.8148 0.185263 16 0.421053 16H2.98105C3.09053 16 3.2 15.9579 3.27579 15.8737L12.4716 6.68636L9.31369 3.52846L0.126316 12.7158C0.0421053 12.8 0 12.9011 0 13.019ZM14.9137 4.24425C14.9918 4.16635 15.0537 4.07381 15.0959 3.97194C15.1382 3.87006 15.16 3.76086 15.16 3.65057C15.16 3.54028 15.1382 3.43107 15.0959 3.3292C15.0537 3.22733 14.9918 3.13479 14.9137 3.05688L12.9432 1.08636C12.8653 1.00829 12.7727 0.946356 12.6708 0.904098C12.569 0.861839 12.4598 0.840088 12.3495 0.840088C12.2392 0.840088 12.13 0.861839 12.0281 0.904098C11.9262 0.946356 11.8337 1.00829 11.7558 1.08636L10.2147 2.62741L13.3726 5.7853L14.9137 4.24425Z" :fill="color"/>
    </svg>

</template>

<script>
export default {
  name: 'EditIcon',
  props: ['size','color']
}
</script>
